import { actionWithDatapoint } from 'owa-analytics-actions';

export const toggleTaskCompletion = actionWithDatapoint(
    'OUTLOOKSPACES_TOGGLE_TASK_COMPLETION',
    (taskId: string, isComplete: boolean) => ({ taskId, isComplete }),
    ({ isComplete }) => ({ customData: { isComplete_1: isComplete }, options: { isCore: true } })
);

export const toggleSubTaskCompletion = actionWithDatapoint(
    'OUTLOOKSPACES_TOGGLE_SUBTASK_COMPLETION',
    (parentTaskId: string, subtaskId: string, isComplete: boolean) => ({
        parentTaskId,
        subtaskId,
        isComplete,
    }),
    ({ isComplete }) => ({ customData: { isComplete_1: isComplete } })
);
